import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/catalogos/caracter-de-nombramiento/';

/**
 * GET Caracter De Nombramiento Generales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCaracteresDeNombramiento = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Caracter De Nombramiento general
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCaracterDeNombramiento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Caracter De Nombramiento General
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCaracterDeNombramiento = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Caracter De Nombramiento General
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCaracterDeNombramiento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Caracter De Nombramiento General
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCaracterDeNombramiento = async (id) => {
  try {
    const response = await API.delete(`${baseURI} ${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
